// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__oOtCS","backdrop":"Modal_backdrop__R4Mne"};